export default __webpack_public_path__ + "static/media/5.48c0016f.png";